const DeviceType = {
  audioInput: 'audioinput',
  audioOutput: 'audiooutput',
  videoInput: 'videoinput',
};

export default DeviceType;
